import { Text } from '@shopify/polaris';

interface ActionTemplateProps {
  actionLabel: string;
  onHandleAction: () => void;
}

export const ActionTemplate = ({ actionLabel, onHandleAction }: ActionTemplateProps) => {
  const handleAction = (e: React.MouseEvent) => {
    e.stopPropagation();
    onHandleAction();
  };
  return (
    <Text as="span" variant="bodySm">
      <span className="underline cursor-pointer" onClick={handleAction}>
        {actionLabel}
      </span>{' '}
    </Text>
  );
};
